module.exports = __webpack_public_path__ + "static/media/covit.2a200184.svg";